import { render, staticRenderFns } from "./ModalInventoryData.vue?vue&type=template&id=6aab5644&scoped=true&"
import script from "./ModalInventoryData.vue?vue&type=script&lang=js&"
export * from "./ModalInventoryData.vue?vue&type=script&lang=js&"
import style0 from "./ModalInventoryData.vue?vue&type=style&index=0&id=6aab5644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab5644",
  null
  
)

export default component.exports